import { axiosInstance } from '../request';
import { filterThreadHistoryItems } from './threads.utils';
export const getThreads = async () => {
    const response = await axiosInstance.get('/api/v1/threads');
    return new Map(Object.entries(response.data));
};
// TODO: Change. Add paging and search on BE side
/** @deprecated */
export const getThreadHistory = async () => {
    const response = await axiosInstance.get(`/api/v1/threads/history`);
    const flatItems = response.data.map((t) => t.thread_list).flat();
    return filterThreadHistoryItems(flatItems);
};
export const getThreadHistoryPage = async (data) => {
    const response = await axiosInstance.get(`/api/v1/threads/historical?from=${data.from}&limit=${data.limit}`);
    const page = response.data;
    return { existsMore: page.existsMore, items: filterThreadHistoryItems(page.items) };
};
//# sourceMappingURL=threads.api.js.map